import React, { useEffect, useRef, useState } from "react";
import "../../../assets/scss/components/sections/resumes/interviewQuestions.scss";
import "../../../assets/scss/components/sections/library/resume/resume.scss";

import followUpIcon from "../../../assets/images/resume/follow-up.svg";
import redFlag from "../../../assets/images/resume/red-flags.svg";
import keyPoints from "../../../assets/images/resume/key-points.svg";
import { Col, Image, Row } from "react-bootstrap";
import Slider from "react-slick";

import leftScroll from "../../../assets/images/home/left-scroll.svg";
import rightScroll from "../../../assets/images/home/right-scroll.svg";
const Questionnaire = ({ questionsData }) => {
  const [currentCategoryIndex, setCurrentCategoryIndex] = useState(0);
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [questions, setQuestions] = useState([]);
  const [currentQuestion, setCurrentQuestion] = useState(null);
  const sliderRef = useRef(null);

  const handleQuestionClick = (index) => {
    setCurrentCategoryIndex(index);
    setCurrentQuestionIndex(0);
  };

  const handlePrevious = () => {
    if (currentCategoryIndex > 0) {
      sliderRef.current.slickPrev();
      setCurrentCategoryIndex((prev) => prev - 1);
    }
  };

  const handleNext = () => {
    if (currentCategoryIndex < questionsData.length - 1) {
      sliderRef.current.slickNext();
      setCurrentCategoryIndex((prev) => prev + 1);
    }
  };
  const sliderSettings = {
    className: "slider variable-width",
    dots: false,
    infinite: false,
    speed: 500,
    slidesToScroll: 1,
    variableWidth: true,
    afterChange: (current) => {
      setCurrentCategoryIndex(current);
    },
    responsive: [
      {
        breakpoint: 573,
        settings: {
          slidesToScroll: 1,
          slidesToShow: 1,
          variableWidth: true,
          centerMode: false,
          centerPadding: "20px",
        },
      },
    ],
  };
  const handlePrevClick = () => {
    if (currentCategoryIndex > 0) {
      sliderRef.current.slickPrev();

      setCurrentCategoryIndex((prev) => prev - 1);
    }
  };

  const handleNextClick = () => {
    if (currentCategoryIndex < (questionsData?.length - 1 || 0)) {
      sliderRef.current.slickNext();
      setCurrentCategoryIndex((prev) => prev + 1);
    }
  };
  const isPrevDisabled = currentCategoryIndex === 0;
  const isNextDisabled =
    currentCategoryIndex >= (questionsData?.length - 1 || 0);
  useEffect(() => {
    if (questionsData && questionsData.length > 0) {
      const currentCategory = questionsData[currentCategoryIndex];
      if (currentCategory?.questions?.length > 0) {
        setQuestions(currentCategory.questions);
        setCurrentQuestion(currentCategory.questions[currentQuestionIndex]);
      }
    }
  }, [questionsData, currentQuestionIndex, currentCategoryIndex]);

  if (!questionsData || questionsData.length === 0) {
    return <div>No questions available</div>;
  }

  return (
    <div className="questionnaire-container">
      <div className="category-wrapper">
        <button
          className={`nav-arrow left-arrow ${isPrevDisabled ? "disabled" : ""}`}
          onClick={handlePrevClick}
          disabled={isPrevDisabled}
        >
          <Image src={leftScroll} />
        </button>
        <Slider
          {...sliderSettings}
          ref={sliderRef}
          className="resume-switch-buttons text-center mb-4 category-question-no"
        >
          {questionsData.map((question, index) => (
            <div
              key={index}
              className={`question-about ${
                currentCategoryIndex === index ? "active" : ""
              }`}
              onClick={() => handleQuestionClick(index)}
            >
              <h6 className="no">{index + 1}</h6>
              <h6 className="about">{question?.category}</h6>
            </div>
          ))}
        </Slider>

        <button
          className={`nav-arrow right-arrow ${
            isNextDisabled ? "disabled" : ""
          }`}
          onClick={handleNextClick}
          disabled={isNextDisabled}
        >
          <Image src={rightScroll} />
        </button>
      </div>
      <div className="question-no">
        {questionsData.map((question, index) => (
          <div
            key={index}
            className={`question-about ${
              currentCategoryIndex === index ? "active" : ""
            }`}
            onClick={() => handleQuestionClick(index)}
          >
            <h6 className="no">{index + 1}</h6>
            <h6 className="about">{question?.category}</h6>
          </div>
        ))}
      </div>
      <div className="question-content">
        <div className="question-detail">
          <h6 className="about">
            {questionsData[currentCategoryIndex]?.category}
          </h6>
          <p className="detail">
            {questionsData[currentCategoryIndex]?.category_description}
          </p>
        </div>
        {questions?.map((question, index) => (
            <>
              <h6 className="question-heading">{`Question ${index + 1}`} </h6>
              <p className="question">{question?.question}</p>
              <div className="d-md-flex mb-3">
                <h6 className="difficulty mb-3 mb-md-0">
                  Difficulty <span>{question?.metadata?.difficulty}</span>
                </h6>
                <h6 className="type mb-3 mb-md-0">
                  Question <span>{question?.metadata?.question_type}</span>
                </h6>
                <h6 className="skills">
                  Skills{" "}
                  <span>{question?.metadata?.skills_tested?.join(", ")}</span>
                </h6>
              </div>
              <div className="expected-answer">
                <h4>Expected Answer</h4>
                <p>{question?.expected_answer}</p>
              </div>

              <div className="follow-up-qest">
                <div className="d-flex align-items-center mb-2">
                  <Image src={followUpIcon} className="me-3"/>
                  <h6>Follow-up questions</h6>
                </div>
                {question?.metadata?.follow_up_questions?.map(
                    (followUp, index) => (
                        <div key={index} className="follow-up-question">
                          <p>
                            {index + 1}. {followUp}
                          </p>
                        </div>
                    )
                )}
              </div>
              <Row className="mb-4">
                <Col md={6} className="mb-3 mb-md-0">
                  <div className="key-evaluation points">
                    <div className="icon">
                      <Image src={keyPoints}/>
                    </div>
                    <h6 className="heading">Key Evaluation Points</h6>
                    {question?.metadata?.key_evaluation_points?.map(
                        (point, i) => (
                            <p key={i}>
                              {i + 1}. {point}
                            </p>
                        )
                    )}
                  </div>
                </Col>
                <Col md={6}>
                  <div className="red-flags points">
                    <div className="icon">
                      <Image src={redFlag}/>
                    </div>
                    <h6 className="heading">Red flags in answers</h6>
                    {question?.metadata?.red_flags_in_answers?.map((flag, i) => (
                        <p key={i}>
                          {i + 1}. {flag}
                        </p>
                    ))}
                  </div>
                </Col>
              </Row>
              <hr/>
            </>
        ))}
      </div>

      <div className="question-controls">
        <button
          onClick={handlePrevious}
          disabled={currentCategoryIndex === 0 && currentQuestionIndex === 0}
        >
          Prev
        </button>
        <button
          onClick={handleNext}
          disabled={
            currentCategoryIndex === questionsData.length - 1 &&
            currentQuestionIndex ===
              questionsData[currentCategoryIndex]?.questions?.length - 1
          }
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Questionnaire;
